import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  Button,
  CircularProgress,
  createTheme,
  Grid,
  Link,
  TextField,
  Typography,
} from '@mui/material'
import HeaderTitle from '../Header/HeaderTitle'
import {
  getLocationInformation,
  getLocationProjects,
  getLocationIncidents,
} from '../../store/LocationProjects/actionCreator'
import { formatLocationNumber } from '../../common/tLocationNumbers'
import MrtReusableTable from '../Utils/MrtReusableTable'
import Search from '@mui/icons-material/Search'
import {
  handleFireflySendEvent,
  handleFireflySendClickEvent,
} from '../Utils/FireFlyVnextHelpers'

function withParams(Component) {
  return (props) => (
    <Component {...props} params={useParams()} navigate={useNavigate()} />
  )
}

export class LocationProjects extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      location: '',
      locationIncidents: [],
      locationProjects: [],
      locationInformation: '',
      loading: false,
      locationNumber: '',
      notFoundMessage: '',
    }
    this.displayHours = this.displayHours.bind(this)
    this.formatTime = this.formatTime.bind(this)
    this.handleOnSearch = this.handleOnSearch.bind(this)
    this.baseState = { ...this.state }
  }

  static defaultProps = {
    userInfo: {
      email: undefined,
    },
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { locationId } = this.props.params
    if (
      nextProps.locationIncidents.length &&
      nextProps.locationProjects.length &&
      typeof locationId !== 'undefined'
    ) {
      this.displayLocationIncidents(nextProps)
      this.displayLocationProjects(nextProps)
      this.displayLocationInformation(nextProps)
    }
  }

  async componentDidMount() {
    const { userInfo } = this.props
    const { locationId } = this.props.params
    if (userInfo.email !== '') {
      handleFireflySendEvent(
        'PAGE_VIEW',
        'Location Projects',
        'Location Projects Page Load',
        userInfo,
      )
    }
    if (locationId !== '' && typeof locationId !== 'undefined') {
      this.setState({ loading: true })
      await this.props.getLocationInformation(locationId)
      await this.props.getLocationIncidents(locationId)
      await this.props.getLocationProjects(locationId)
      this.setState({ loading: false })
    }
  }

  async handleOnSearch(event) {
    const { userInfo } = this.props
    const navigate = this.props.navigate

    handleFireflySendClickEvent(
      'CLICK',
      'Location Projects',
      'Location Projects - Search',
      userInfo,
    )
    event.preventDefault()
    this.setState({ ...this.baseState, loading: true })
    var formattedLocationNumber = formatLocationNumber(
      this.state.locationNumber,
    )
    navigate('/LocationProjects/' + formattedLocationNumber)
    await this.props.getLocationInformation(formattedLocationNumber)
    await this.props.getLocationIncidents(formattedLocationNumber)
    await this.props.getLocationProjects(formattedLocationNumber)
    this.setState({ loading: false })
  }

  displayLocationInformation = (nextProps) => {
    if (nextProps.locationInformation[0] === 'Location Not Found!') {
      this.setState({
        location: '',
        locationInformation: '',
        locationIncidents: [],
        locationProjects: [],
        notFoundMessage: 'Location Not Found!',
      })
    } else {
      this.setState({
        location: nextProps.location,
        locationInformation: JSON.parse(
          JSON.stringify(nextProps.locationInformation),
        ),
        notFoundMessage: '',
      })
    }
  }

  displayLocationIncidents = (nextProps) => {
    if (nextProps.locationIncidents[0] === 'Location Not Found!') {
      this.setState({
        location: 'Location Not Found!',
        locationIncidents: [],
      })
    } else if (nextProps.locationIncidents[0] === 'No Active Incidents!') {
      this.setState({
        location: nextProps.location,
        locationIncidents: 'No Active Incidents!',
        notFoundMessage: '',
      })
    } else {
      this.setState({
        location: nextProps.location,
        locationIncidents: JSON.parse(
          JSON.stringify(nextProps.locationIncidents),
        ),
        notFoundMessage: '',
      })
    }
  }

  displayLocationProjects = (nextProps) => {
    if (nextProps.locationProjects[0] === 'Location Not Found!') {
      this.setState({
        location: 'Location Not Found!',
        locationProjects: [],
      })
    } else if (nextProps.locationProjects[0] === 'No Projects Found!') {
      this.setState({
        location: nextProps.location,
        locationProjects: 'No Projects Found!',
        notFoundMessage: '',
      })
    } else {
      this.setState({
        location: nextProps.location,
        locationProjects: JSON.parse(
          JSON.stringify(nextProps.locationProjects),
        ),
        notFoundMessage: '',
      })
    }
  }

  displayHours = () => {
    let operatingHours
    if (this.state.locationInformation[0].hours.length <= 1) {
      operatingHours = <div>N/A</div>
    } else {
      operatingHours = (
        <div>
          <b>{this.state.locationInformation[0].hours[0].day}:</b> {'   '}
          {this.state.locationInformation[0].hours[0].begin_time !== null
            ? this.formatTime(
                this.state.locationInformation[0].hours[0].begin_time,
              )
            : 'N/A'}{' '}
          -{' '}
          {this.state.locationInformation[0].hours[0].end_time !== null
            ? this.formatTime(
                this.state.locationInformation[0].hours[0].end_time,
              )
            : 'N/A'}
          <br />
          <b>{this.state.locationInformation[0].hours[1].day}:</b> {'   '}
          {this.state.locationInformation[0].hours[1].begin_time !== null
            ? this.formatTime(
                this.state.locationInformation[0].hours[1].begin_time,
              )
            : 'N/A'}{' '}
          -{' '}
          {this.state.locationInformation[0].hours[1].end_time !== null
            ? this.formatTime(
                this.state.locationInformation[0].hours[1].end_time,
              )
            : 'N/A'}
          <br />
          <b>{this.state.locationInformation[0].hours[2].day}:</b> {'  '}
          {this.state.locationInformation[0].hours[2].begin_time !== null
            ? this.formatTime(
                this.state.locationInformation[0].hours[2].begin_time,
              )
            : 'N/A'}{' '}
          -{' '}
          {this.state.locationInformation[0].hours[2].end_time !== null
            ? this.formatTime(
                this.state.locationInformation[0].hours[2].end_time,
              )
            : 'N/A'}
          <br />
          <b>{this.state.locationInformation[0].hours[3].day}:</b> {'   '}
          {this.state.locationInformation[0].hours[3].begin_time !== null
            ? this.formatTime(
                this.state.locationInformation[0].hours[3].begin_time,
              )
            : 'N/A'}{' '}
          -{' '}
          {this.state.locationInformation[0].hours[3].end_time !== null
            ? this.formatTime(
                this.state.locationInformation[0].hours[3].end_time,
              )
            : 'N/A'}
          <br />
          <b>{this.state.locationInformation[0].hours[4].day}:</b> {'   '}
          {this.state.locationInformation[0].hours[4].begin_time !== null
            ? this.formatTime(
                this.state.locationInformation[0].hours[4].begin_time,
              )
            : 'N/A'}{' '}
          -{' '}
          {this.state.locationInformation[0].hours[4].end_time !== null
            ? this.formatTime(
                this.state.locationInformation[0].hours[4].end_time,
              )
            : 'N/A'}
          <br />
          <b>{this.state.locationInformation[0].hours[5].day}:</b> {'   '}
          {this.state.locationInformation[0].hours[5].begin_time !== null
            ? this.formatTime(
                this.state.locationInformation[0].hours[5].begin_time,
              )
            : 'N/A'}{' '}
          -{' '}
          {this.state.locationInformation[0].hours[5].end_time !== null
            ? this.formatTime(
                this.state.locationInformation[0].hours[5].end_time,
              )
            : 'N/A'}
          <br />
          <b>{this.state.locationInformation[0].hours[6].day}:</b> {'   '}
          {this.state.locationInformation[0].hours[6].begin_time !== null
            ? this.formatTime(
                this.state.locationInformation[0].hours[6].begin_time,
              )
            : 'N/A'}{' '}
          -{' '}
          {this.state.locationInformation[0].hours[6].end_time !== null
            ? this.formatTime(
                this.state.locationInformation[0].hours[6].end_time,
              )
            : 'N/A'}
        </div>
      )
    }
    return operatingHours
  }

  formatTime = (unformattedTime) => {
    const timeArray = unformattedTime.split(':')
    var hours =
      timeArray[0].charAt(0) === '0' ? timeArray[0].charAt(1) : timeArray[0]
    const minutes = timeArray[1]
    var amPm
    if (hours === 0) {
      hours = 12
      amPm = 'AM'
    } else if (hours === 12) {
      amPm = 'PM'
    } else if (hours > 12) {
      hours = hours - 12
      amPm = 'PM'
    } else {
      amPm = 'AM'
    }
    return hours + ':' + minutes + ' ' + amPm
  }

  expandedRowMuiTheme = () =>
    createTheme({
      components: {
        MUIDataTableToolbar: {
          styleOverrides: {
            root: {
              backgroundColor: '#e0e0e0',
              minHeight: '8px',
            },
          },
        },
      },
    })

  render() {
    const ulStyle = {
      columnCount: 2,
      padding: 0,
      marginTop: 0,
    }
    let information
    if (
      this.state.locationInformation.length > 0 &&
      this.state.locationInformation[0] !== 'Location Not Found!'
    ) {
      let capabilities
      if (this.state.locationInformation[0].capabilities[0] !== null) {
        capabilities = this.state.locationInformation[0].capabilities.map(
          (capability, index) => (
            <li key={index}>{capability.capability_name}</li>
          ),
        )
      } else {
        capabilities = 'N/A'
      }
      let osbr
      if (this.state.locationInformation[0].osbr === 'N/A') {
        osbr = this.state.locationInformation[0].osbr
      } else {
        const osbrArray = this.state.locationInformation[0].osbr.split(' ')
        let osbrDate = osbrArray[2].split('-')
        osbrDate = osbrDate[1] + '/' + osbrDate[2] + '/' + osbrDate[0]
        osbr = this.state.locationInformation[0].osbr.replace(
          osbrArray[2],
          osbrDate,
        )
      }
      information = (
        <div>
          <h3 style={{ paddingBottom: '0px' }}>
            <u>
              <b style={{ fontSize: '38px' }}>
                Store {this.state.location}
                {this.state.locationInformation[0].name !== null
                  ? ' - ' + this.state.locationInformation[0].name
                  : ''}
              </b>
            </u>
          </h3>
          <u>
            <b>General</b>
          </u>
          <br />
          <b>Model: </b>{' '}
          {this.state.locationInformation[0].model !== null
            ? this.state.locationInformation[0].model
            : 'N/A'}
          &nbsp;
          <b>Region: </b>
          {this.state.locationInformation[0].region !== null
            ? this.state.locationInformation[0].region
            : 'N/A'}{' '}
          <b>Timezone: </b>
          {this.state.locationInformation[0].timezone !== null
            ? this.state.locationInformation[0].timezone
            : 'N/A'}
          <br />
          <b>Address:</b>{' '}
          {this.state.locationInformation[0].address !== null
            ? this.state.locationInformation[0].address
            : 'N/A'}
          <br />
          <b>Phone:</b>{' '}
          {this.state.locationInformation[0].phone !== null
            ? this.state.locationInformation[0].phone
            : 'N/A'}
          &nbsp;
          <b>OSBR: </b> {osbr}
          &nbsp;
          <b>Last Remodel Date: </b>
          {this.state.locationInformation[0].lastRemodelDate != null
            ? this.state.locationInformation[0].lastRemodelDate
            : 'N/A'}
          <br /> <br />
          <Grid container>
            <Grid item size={{ xs: 5 }}>
              <u>
                <b>Hours</b>
              </u>
              {this.displayHours()}
            </Grid>
            <Grid item size={{ xs: 7 }}>
              <u>
                <b>Capabilities</b>
              </u>
              <ul style={ulStyle}>{capabilities}</ul>
            </Grid>
          </Grid>
        </div>
      )
    } else {
      information = this.state.locationInformation
    }

    let incidents = []
    if (
      this.state.locationIncidents.length > 0 &&
      this.state.locationIncidents !== 'No Active Incidents!'
    ) {
      const incidentColumns = [
        {
          header: 'Incident Number',
          accessorKey: 'incident_number',
          Cell: ({ row }) => (
            <Link
              href={row.original.incident_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {row.original.incident_number}
            </Link>
          ),
        },
        {
          header: 'Description',
          accessorKey: 'short_description',
        },
        { header: 'Business Impact', accessorKey: 'business_impact' },
        {
          header: 'Assignment Group',
          accessorKey: 'assignment_group',
        },
        { header: 'State', accessorKey: 'state' },
        {
          header: 'Time Opened',
          accessorKey: 'time_opened',
          Cell: ({ cell }) => {
            const value = cell.getValue()
            return value ? new Date(value).toLocaleDateString() : ''
          },
        },
        {
          header: 'Url',
          accessorKey: 'incident_url',
        },
      ]
      const incidentDefaultColumns = [
        'incident_number',
        'short_description',
        'business_impact',
        'assignment_group',
        'state',
        'time_opened',
      ]
      incidents = (
        <MrtReusableTable
          pageSize={[4, 10, 20]}
          pageTitle={'Incidents'}
          columns={incidentColumns}
          rowData={this.props.locationIncidents}
          defaultColumns={incidentDefaultColumns}
        />
      )
    } else {
      incidents = this.state.locationIncidents
    }

    let projects = []
    if (
      this.state.locationProjects.length > 0 &&
      this.state.locationProjects !== 'No Projects Found!'
    ) {
      const columns = [
        {
          accessorKey: 'health',
          header: 'Health',
          description:
            'Support: Red/Yellow -> send to R&D, Blue/Green -> normal support',
          size: 70,
        },
        {
          accessorKey: 'project_name',
          header: 'Project | Scope Name:',
          description:
            'Project identifier and scope name. Format: PROJECT_ID | Descriptive scope name with details about deployment phase, technology stack, and geographical coverage area.',
          size: 300,
          grow: true,
        },
        {
          accessorKey: 'start_date',
          header: 'Execution Period Start Date',
        },
        {
          accessorKey: 'end_date',
          header: 'Execution Period End Date',
        },
        {
          accessorKey: 'scheduled_status',
          header: 'Scheduled Status',
          description: 'Short test: Status type',
        },
        {
          accessorKey: 'status',
          header: 'Scope Status',
          size: 120,
        },
        {
          accessorKey: 'number_of_revisits',
          header: 'Number Of Revisits',
        },
        {
          accessorKey: 'work_start_date',
          header: 'Work Start Date',
          size: 130,
        },
        {
          accessorKey: 'work_end_date',
          header: 'Work End Date',
          size: 120,
        },
        {
          accessorKey: 'work_time_frame',
          header: 'Hours | Time Frame of Work',
          size: 210,
        },
        {
          accessorKey: 'percentage_complete',
          header: '% Complete',
          size: 110,
        },
        {
          accessorKey: 'conditional_sign_off_notes',
          header: 'Conditional Signoff Notes',
        },
        {
          accessorKey: 'period',
          header: 'Execution Period',
        },
        {
          accessorKey: 'delay_reason',
          header: 'Delay Reason',
        },
        {
          accessorKey: 'notes',
          header: 'Notes',
        },
        {
          accessorKey: 'turnover',
          header: 'Turnover Date',
        },
        {
          accessorKey: 'go_live_date',
          header: 'Go Live Date',
        },
        {
          accessorKey: 'vendor_project_manager',
          header: 'Vendor PM',
        },
        {
          accessorKey: 'vendor_visit_dates',
          header: 'Vendor Visit Dates',
        },
        {
          accessorKey: 'construction_pm',
          header: 'Construction PM',
        },
        {
          accessorKey: 'tts_project_manager',
          header: 'TTS Project Manager',
          size: 200,
          grow: true,
        },
        {
          accessorKey: 'consolidation_vendor',
          header: 'Consolidation Vendor',
        },
        {
          accessorKey: 'installation_vendor',
          header: 'Installation Vendor',
        },
        {
          accessorKey: 'low_voltage_vendor',
          header: 'Low Voltage Vendor',
        },
        {
          accessorKey: 'deployment_support_vendor',
          header: 'Vendor Responsible for Scope',
        },
        {
          accessorKey: 'tts_project_team',
          header: 'TTS Execution Team',
        },
        {
          accessorKey: 'sheet_url',
          header: 'Smartsheet URL',
        },
        {
          accessorKey: 'sheet_name',
          header: 'Smartsheet Name',
        },
        {
          accessorKey: 'project_summary',
          header: 'Project Summary',
        },
        {
          accessorKey: 'store_action_required',
          header: 'Store Action Required',
        },
        {
          accessorKey: 'hardware_arriving',
          header: 'Hardware Arriving',
        },
        {
          accessorKey: 'access_areas',
          header: 'Access Areas',
        },
        {
          accessorKey: 'time_to_task',
          header: 'Time to Task',
        },
        {
          accessorKey: 'time_of_day',
          header: 'Time of Day',
        },
        {
          accessorKey: 'question_resource',
          header: 'Question Resource',
        },
        {
          accessorKey: 'question_address',
          header: 'Question Address',
        },
        {
          accessorKey: 'pos_scope',
          header: 'Project has POS Scope',
        },
        {
          accessorKey: 'vendors_have_pin',
          header: 'Vendors will have control room PIN',
        },
        {
          accessorKey: 'rd_pin',
          header: 'R&D Pin',
        },
        {
          accessorKey: 'scope_project_identification',
          header: 'Scope Project Identification',
        },
      ]
      const defaultColumns = [
        'health',
        'project_name',
        'status',
        'work_start_date',
        'work_end_date',
        'work_time_frame',
        'percentage_complete',
        'tts_project_manager',
        'tts_project_team',
      ]
      // Function that returns grouped data for the expanded row (based on original MUIDataTable structure)
      const expandedRowGroups = (rowData) => [
        {
          title: 'Project Details',
          columns: [
            { header: 'Health', accessorKey: 'health' },
            { header: 'Project | Scope Name', accessorKey: 'project_name' },
            { header: 'Execution Period', accessorKey: 'period' },
            { header: 'Scope Status', accessorKey: 'status' },
            { header: '% Complete', accessorKey: 'percentage_complete' },
            { header: 'Scheduled Status', accessorKey: 'scheduled_status' },
            {
              header: 'Conditional Signoff Notes',
              accessorKey: 'conditional_sign_off_notes',
            },
            { header: 'Delay Reason', accessorKey: 'delay_reason' },
          ],
          data: [
            {
              location_id: rowData.location_id,
              health: rowData.health,
              project_name: rowData.project_name,
              period: rowData.period,
              status: rowData.status,
              percentage_complete: rowData.percentage_complete,
              scheduled_status: rowData.scheduled_status,
              conditional_sign_off_notes: rowData.conditional_sign_off_notes,
              delay_reason: rowData.delay_reason,
            },
          ],
        },
        {
          title: 'Project Timelines',
          columns: [
            { header: 'Work Start Date', accessorKey: 'work_start_date' },
            { header: 'Work End Date', accessorKey: 'work_end_date' },
            {
              header: 'Execution Period Start Date',
              accessorKey: 'start_date',
            },
            { header: 'Execution Period End Date', accessorKey: 'end_date' },
            {
              header: 'Hours | Time Frame of Work',
              accessorKey: 'work_time_frame',
            },
            { header: 'Turnover Date', accessorKey: 'turnover' },
            { header: 'Go Live Date', accessorKey: 'go_live_date' },
            { header: 'Vendor Visit Dates', accessorKey: 'vendor_visit_dates' },
          ],
          data: [
            {
              work_start_date: rowData.work_start_date,
              work_end_date: rowData.work_end_date,
              start_date: rowData.start_date,
              end_date: rowData.end_date,
              work_time_frame: rowData.work_time_frame,
              turnover: rowData.turnover,
              go_live_date: rowData.go_live_date,
              vendor_visit_dates: rowData.vendor_visit_dates,
            },
          ],
        },
        {
          title: 'Contact Information',
          columns: [
            { header: 'Vendor PM', accessorKey: 'vendor_project_manager' },
            { header: 'TTS Execution Team', accessorKey: 'tts_project_team' },
            {
              header: 'TTS Project Manager',
              accessorKey: 'tts_project_manager',
            },
            { header: 'Construction PM', accessorKey: 'construction_pm' },
            {
              header: 'Consolidation Vendor',
              accessorKey: 'consolidation_vendor',
            },
            {
              header: 'Vendor Responsible for Scope',
              accessorKey: 'deployment_support_vendor',
            },
          ],
          data: [
            {
              vendor_project_manager: rowData.vendor_project_manager,
              tts_project_team: rowData.tts_project_team,
              tts_project_manager: rowData.tts_project_manager,
              construction_pm: rowData.construction_pm,
              consolidation_vendor: rowData.consolidation_vendor,
              deployment_support_vendor: rowData.deployment_support_vendor,
            },
          ],
        },
        {
          title: 'Project Summary',
          columns: [
            { header: 'Project Summary', accessorKey: 'project_summary' },
            {
              header: 'Store Action Required',
              accessorKey: 'store_action_required',
            },
            { header: 'Hardware Arriving', accessorKey: 'hardware_arriving' },
            { header: 'Access Areas', accessorKey: 'access_areas' },
            { header: 'Time to Task', accessorKey: 'time_to_task' },
            { header: 'Time of Day', accessorKey: 'time_of_day' },
            { header: 'Question Resource', accessorKey: 'question_resource' },
            { header: 'Question Address', accessorKey: 'question_address' },
            { header: 'Project has POS Scope', accessorKey: 'pos_scope' },
            {
              header: 'Vendors will have control room PIN',
              accessorKey: 'vendors_have_pin',
            },
          ],
          data: [
            {
              project_summary: rowData.project_summary,
              store_action_required: rowData.store_action_required,
              hardware_arriving: rowData.hardware_arriving,
              access_areas: rowData.access_areas,
              time_to_task: rowData.time_to_task,
              time_of_day: rowData.time_of_day,
              question_resource: rowData.question_resource,
              question_address: rowData.question_address,
              pos_scope: rowData.pos_scope,
              vendors_have_pin: rowData.vendors_have_pin,
            },
          ],
        },
        {
          title: 'Misc',
          columns: [
            { header: 'Smartsheet Link', accessorKey: 'sheet_name' },
            { header: 'Notes', accessorKey: 'notes' },
          ],
          data: [
            {
              sheet_name:
                rowData.sheet_url && rowData.sheet_name ? (
                  <a
                    href={rowData.sheet_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#1976d2', textDecoration: 'none' }}
                  >
                    {rowData.sheet_name}
                  </a>
                ) : (
                  rowData.sheet_name || '-'
                ),
              notes: rowData.notes,
            },
          ],
        },
      ]

      projects = (
        <MrtReusableTable
          pageSize={[10, 20, 50]}
          pageTitle={'R&D Active Projects'}
          columns={columns}
          rowData={this.state.locationProjects}
          defaultColumns={defaultColumns}
          loading={this.state.loading}
          loadingMessage="&nbsp;R&D Active Projects Loading..."
          enableExpanding={true}
          expandedRowGroups={expandedRowGroups}
        />
      )
    } else {
      projects = this.state.locationProjects
    }

    const incidentPanel = <div>{incidents}</div>
    const projectPanel = <div>{projects}</div>

    return (
      <div>
        <HeaderTitle title="Location Projects" />
        {this.state.loading ? (
          <Grid
            container
            spacing={16}
            justifyContent={'center'}
            className="progress"
          >
            <CircularProgress />
            <Typography className="loading">&nbsp;Loading...</Typography>
          </Grid>
        ) : (
          <Grid item size={{ xs: 12 }}>
            <Grid container>
              <Grid item size={{ xs: 4 }}>
                <form onSubmit={this.handleOnSearch}>
                  <TextField
                    type="text"
                    variant="standard"
                    value={this.state.locationNumber}
                    onChange={(event) =>
                      this.setState({ locationNumber: event.target.value })
                    }
                    placeholder="Enter location number"
                    required
                    slotProps={{
                      className: 'redUnderline',
                    }}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={!this.state.locationNumber}
                    type="submit"
                  >
                    <Search />
                    search
                  </Button>
                </form>
              </Grid>
              <Grid item size={{ xs: 8 }}>
                <Typography variant="h4">
                  {this.state.notFoundMessage}
                </Typography>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item size={{ xs: 12, md: 5 }}>
                {information}
              </Grid>
              <Grid item size={{ xs: 12, md: 7 }}>
                {incidentPanel}
              </Grid>
              <Grid item size={{ xs: 12 }}>
                {projectPanel}
              </Grid>
            </Grid>
          </Grid>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    locationInformation: state.locationProjects.locationInformation,
    locationProjects: state.locationProjects.locationProjects,
    locationIncidents: state.locationProjects.locationIncidents,
    location: state.locationProjects.location,
    userInfo: state.auth.userInfo,
  }
}

const mapDispatchToProps = {
  getLocationInformation,
  getLocationProjects,
  getLocationIncidents,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withParams(LocationProjects))
